import {Dispatch, SetStateAction, useCallback, useState} from "react";

export const useToggle = (initial: boolean = false)
    : [boolean, () => void, Dispatch<SetStateAction<boolean>>] => {
  const [state, setState] = useState<boolean>(initial);
  const toggle = useCallback((): void => {
    setState((state: boolean) => !state);
  }, []);
  return [state, toggle, setState];
};